import React, { useEffect, useContext, useState, useRef } from "react";
import { TokenVerificationLoggedin, BlockAdmin } from "../../../../utils/tokenVerify";
import { LoadingContext } from "react-router-loading";
import axios from "axios";
import Cookies from "js-cookie";
import configData from "../../../../config/config.json";
import { useLocation } from "react-router-dom";
import { Table, Select, Col, Row, Pagination, Input, Switch, Checkbox, Tooltip } from 'antd';
import { Link } from 'react-router-dom'
import { notifysuccess } from "../../../../utils/toast";
import { notifyfailure } from "../../../../utils/toast";
import { notifycatch } from "../../../../utils/toast";
import FullLoader from "../../../../assets/images/full-page-loader.gif"
import prevIcon from '../../../../assets/images/icons/chevron-left.svg';
import nextIcon from '../../../../assets/images/icons/chevron-right.svg';
import addIcon from '../../../../assets/images/icons/add.svg';
import noData from '../../../../assets/images/data-graph/no-data.svg';
import TableLoader from "../../../TableLoader";
import errorData from '../../../../assets/images/data-graph/error-data.svg';
import CampaignCreateGam from "./CampaignCreateGam/CampaignCreateGam";
import Dropdown from 'react-bootstrap/Dropdown';
import filterIcon from '../../../../assets/images/icons/filter.svg';
import HoverCloseIcon from '../../../../assets/images/icons/hover_close.svg';
import { SearchOutlined } from '@ant-design/icons';
import tagRomoveIcon from '../../../../assets/images/icons/tag_close_icon.svg';
import CampaignViewEditGam from "./CampaignCreateGam/CampaignViewEditGam";


const CampaignListGam = () => {

    const loadingContext = useContext(LoadingContext);
    const [apiCall, setApicall] = useState(false)

    const [pageView, setPageView] = useState("table")

    const [campaignViewId, setCampaignViewId] = useState("")
    const [campaignViewName, setCampaignViewName] = useState("")
    const [campaignViewCreative, setCampaignViewCreative] = useState(false)

    const listTypefromListings = new URLSearchParams(useLocation().search).get("listType");
    const listIdfromListings = new URLSearchParams(useLocation().search).get("listId");



    const columns = [
        {
            title: 'Status',
            dataIndex: 'status',
            key: 'status',
            fixed: 'left',
            width: 100,
            render: (text, record) => <div className='w_100 position-relative'>
                <Select
                    className={`form_select badge_content--${text?.toLowerCase()}`}
                    dropdownStyle={{
                        width: '12rem'
                    }}
                    value={text === "PENDING" ? "Pending" : text}

                    options={[{ label: "Approved", value: "APPROVED" }, { label: "Declined", value: "DECLINED" }]
                    }
                    onChange={(event) => {


                        let status = Cookies.get("token_xapads_ssp") ? true : false;
                        if (status) {
                            let token = Cookies.get("token_xapads_ssp");

                            let payload = {
                                campaignId: record.campaignId,
                                status: event
                            }

                            setLoading(true)
                            axios
                                .post(configData.SERVER_URL + `ops/gam/campaignStatusUpdate`, payload, {
                                    headers: {
                                        "Content-Type": "application/json",
                                        "x-access-token": token,
                                    },
                                })
                                .then((response) => {
                                    setApicall(!apiCall)
                                    notifysuccess(response.data.message);
                                })
                                .catch((error) => {
                                    if (error.response.data.message?.length !== 0) {
                                        notifyfailure(error.response.data.message)
                                    }
                                    else {
                                        notifycatch()
                                    }
                                    setLoading(false)
                                });

                        }
                    }
                    }
                />
            </div>,
        },
        {
            title: 'Active',
            width: 80,
            dataIndex: 'isActive',
            key: 'isActive',
            fixed: 'left',
            // sorter: true,
            render: (text, record) =>
                <>

                    {record.status === "DECLINED" ?
                        <div className="form_content_block--group" onClick={() => { notifyfailure("okay") }}>
                            <Tooltip title="You cannot update activity of a declined campaign. You should update its status first">
                                <Switch checked={text}
                                    disabled
                                />
                            </Tooltip>

                        </div>

                        :
                        <div className="form_content_block--group">
                            <Switch checked={text} onChange={(event) => {

                                let status = Cookies.get("token_xapads_ssp") ? true : false;
                                if (status) {
                                    let token = Cookies.get("token_xapads_ssp");

                                    let payload = {
                                        campaignId: record.campaignId,
                                        active: event,
                                        status: record.status
                                    }

                                    setLoading(true)
                                    axios
                                        .post(configData.SERVER_URL + `ops/gam/campaignActiveUpdate`, payload, {
                                            headers: {
                                                "Content-Type": "application/json",
                                                "x-access-token": token,
                                            },
                                        })
                                        .then((response) => {
                                            setApicall(!apiCall)
                                            notifysuccess(response.data.message);
                                        })
                                        .catch((error) => {
                                            if (error.response.data.message?.length !== 0) {
                                                notifyfailure(error.response.data.message)
                                            }
                                            else {
                                                notifycatch()
                                            }
                                            setLoading(false)
                                        });

                                }

                            }} />
                        </div>
                    }

                </>,
        },
        {
            title: 'ID',
            fixed: 'left',
            dataIndex: 'campaignId',
            key: 'campaignId',
            sorter: true,
            sortDirections: ['ascend', 'descend', 'ascend'],
            render: (text) => <div className='text_dark'>{text}</div>,
        },
        {
            title: 'Campaign Name',
            dataIndex: 'campaign_name',
            key: 'campaign_name',
            sorter: true,
            sortDirections: ['ascend', 'descend', 'ascend'],

            render: (data, record) =>
                <div className='anchor_text_link_d2'
                    onClick={() => {
                        setCampaignViewId(record.campaignId)
                        setCampaignViewName(record.campaign_name)
                        setPageView("viewCampaign");

                    }}
                >{data}</div>,
        },
        {
            title: 'Type',
            dataIndex: 'type',
            key: 'type',
            sorter: true,
            sortDirections: ['ascend', 'descend', 'ascend'],
            // render: (text) => <div className="table_badges--d2 --violet">{text}</div>,
            render: (text) => {
                return (
                    <>

                        <div className={`table_badges--d2 --${text === "IBV" ? "blue" : "violet"}`}>
                            {text}
                        </div>
                    </>
                )
            }
        },
        {
            title: 'Locations',
            dataIndex: 'country',
            key: 'country',
            sortDirections: ['ascend', 'descend', 'ascend'],
            sorter: true,
            render: (data, record) =>
                <div className='text_dark'>
                    {data.length === 0
                        ? "-"
                        : data.length <= 4
                            ? data.join(", ")
                            : data.slice(0, 4).join(", ") + `, +${data.length - 4}`}
                </div>
        },
        {
            title: 'Creatives',
            dataIndex: 'creatives',
            key: 'creatives',
            sortDirections: ['ascend', 'descend', 'ascend'],
            sorter: true,
            render: (data, record) =>

                <div className='text_dark'>
                    {data === 0 ?
                        <Link className="zero_value_design2" style={{ textDecoration: "none", cursor: "default" }} >{data}</Link> :
                        <Link className='text_primary back_area_increase_d2' onClick={() => {
                            setCampaignViewId(record.campaignId)
                            setCampaignViewName(record.campaign_name)
                            setCampaignViewCreative(true)
                            setPageView("viewCampaign");

                        }}>{data}</Link>
                    }

                </div>,
        },
        {
            title: 'Publisher ID',
            dataIndex: 'publisher',
            key: 'publisher',
            sortDirections: ['ascend', 'descend', 'ascend'],
            sorter: true,
            render: (text) => <div className='text_dark'>{text}</div>,
        },
        {
            title: 'Start Date',
            dataIndex: 'startDate',
            key: 'startDate',
            sortDirections: ['ascend', 'descend', 'ascend'],
            sorter: true,
            render: (text) => <div className='text_dark'>
                {/* {Array.isArray(text) ? text.length > 0 ? text[0] !== null ? text[0] : "" : "" : ""} */}
                {text}
            </div>,
        },
        {
            title: 'Bid (Min-Max)',
            dataIndex: 'min_eCPM',
            key: 'min_eCPM',
            sortDirections: ['ascend', 'descend', 'ascend'],
            sorter: true,
            render: (text, record) => <div className='text_dark'>$ {text} - {record["max_eCPM"]}</div>,
        },
        {
            title: 'Daily Budget',
            dataIndex: 'daily_budget',
            key: 'daily_budget',
            width: 120,
            sortDirections: ['ascend', 'descend', 'ascend'],
            sorter: true,
            render: (text) => <div className='text_dark'>$ {text}</div>,
        },
        {
            title: 'Total Budget',
            dataIndex: 'total_budget',
            key: "total_budget",
            sortDirections: ['ascend', 'descend', 'ascend'],
            sorter: true,
            render: (text) => <div className='text_dark'>$ {text}</div>,
        },
        // {
        //     title: 'eCPM',
        //     dataIndex: 'ecpm',
        //     render: () => <div className='text_dark'>$ 1500</div>,
        // },
    ];

    const [data, setData] = useState([])
    const [loading, setLoading] = useState(true)
    const [initialLoad, setInitialLoad] = useState(true)

    const [page, setPage] = useState({
        current: 1,
        pageSize: 50,
        total: 10,
    });

    const [sort, setSort] = useState({
        name: "",
        type: ""
    });

    const [search, setSearch] = useState("")

    const getData = () => {
        setLoading(true)

        if (listIdfromListings && listTypefromListings && initialLoad) {


            axios
                .get(
                    configData.SERVER_URL + `ops/gam/getCampaignIdsByList?listType=${listTypefromListings}&listId=${listIdfromListings}`
                    , {
                        headers: {
                            "Content-Type": "application/json",
                        },
                    })
                .then((response) => {


                    setFilterApply({
                        publisher: [],
                        campaign: response.data.data,
                        status: [],
                    })
                    setFilterApplyApiCall({
                        publisher: [],
                        campaign: response.data.data,
                        status: [],
                    })

                    let status = Cookies.get("token_xapads_ssp") ? true : false;
                    if (status) {
                        let token = Cookies.get("token_xapads_ssp");
                        axios
                            .post(configData.SERVER_URL + `ops/gam/campaignList?sort=${sort.name}&order=${sort.type}&search=${search}&limit=${page.pageSize}&page=${page.current}`,
                                {
                                    filter: {
                                        publisher: [],
                                        campaign: response.data.data,
                                        status: [],
                                    }
                                },
                                {
                                    headers: {
                                        "Content-Type": "application/json",
                                        "x-access-token": token,
                                    },
                                })
                            .then((response) => {
                                setData(response.data.data.data)
                                if (response.data.data.data.length > 0) {
                                    let tempPage = { ...page }
                                    tempPage.total = response.data.data.metaData?.totalRecords
                                    setPage(tempPage)
                                }

                                setLoading(false)
                                setInitialLoad(false)
                            })
                            .catch((error) => {
                                setData([])
                                setLoading(false)
                                setInitialLoad(false)
                            });
                    }
                })
                .catch((error) => {

                    notifyfailure("Failed to apply the campaign filters")

                    let status = Cookies.get("token_xapads_ssp") ? true : false;
                    if (status) {
                        let token = Cookies.get("token_xapads_ssp");
                        axios
                            .post(configData.SERVER_URL + `ops/gam/campaignList?sort=${sort.name}&order=${sort.type}&search=${search}&limit=${page.pageSize}&page=${page.current}`,
                                {
                                    filter: filterApplyApiCall
                                },
                                {
                                    headers: {
                                        "Content-Type": "application/json",
                                        "x-access-token": token,
                                    },
                                })
                            .then((response) => {
                                setData(response.data.data.data)
                                if (response.data.data.data.length > 0) {
                                    let tempPage = { ...page }
                                    tempPage.total = response.data.data.metaData?.totalRecords
                                    setPage(tempPage)
                                }

                                setLoading(false)
                                setInitialLoad(false)
                            })
                            .catch((error) => {
                                setData([])
                                setLoading(false)
                                setInitialLoad(false)
                            });
                    }
                });

        }

        else {

            let status = Cookies.get("token_xapads_ssp") ? true : false;
            if (status) {
                let token = Cookies.get("token_xapads_ssp");
                axios
                    .post(configData.SERVER_URL + `ops/gam/campaignList?sort=${sort.name}&order=${sort.type}&search=${search}&limit=${page.pageSize}&page=${page.current}`,
                        {
                            filter: filterApplyApiCall
                        },
                        {
                            headers: {
                                "Content-Type": "application/json",
                                "x-access-token": token,
                            },
                        })
                    .then((response) => {
                        setData(response.data.data.data)
                        if (response.data.data.data.length > 0) {
                            let tempPage = { ...page }
                            tempPage.total = response.data.data.metaData?.totalRecords
                            setPage(tempPage)
                        }

                        setLoading(false)
                        setInitialLoad(false)
                    })
                    .catch((error) => {
                        setData([])
                        setLoading(false)
                        setInitialLoad(false)
                    });
            }
        }
    }


    useEffect(() => {
        TokenVerificationLoggedin();
        BlockAdmin()
        getData()
        loadingContext.done()
    }, [loadingContext]);



    useEffect(() => {
        if (!initialLoad) {
            getData()
        }
    }, [apiCall])



    useEffect(() => {
        if (!initialLoad
        ) {
            const delayDebounceFn = setTimeout(() => {
                let tempPage = page
                tempPage.current = 1
                setPage(tempPage);
                setApicall(!apiCall)
            }, 400); // 500ms delay
            // Cleanup function to clear the timeout if query changes
            return () => clearTimeout(delayDebounceFn);
        }
    }, [search]);



    const handleTableChange = (pagination, filters, sorter) => {
        setSort({ name: sorter.field, type: sorter.order });
        setApicall(!apiCall)
    };

    const handlePageChange = (data) => {

        let tempPage = page
        tempPage.current = data
        setPage(tempPage);
        setApicall(!apiCall)
    };

    const handlePageSizeChange = (e) => {
        let tempPage = page
        tempPage.pageSize = e

        if (tempPage.current > 1) {
            if (e * tempPage.current > tempPage.total) {
                tempPage.current = 1
            }
        }
        setPage(tempPage);
        setApicall(!apiCall)
    };

    const itemRender = (current, type, originalElement) => {
        if (type === 'prev') {
            return <Link><img src={prevIcon} alt='USP' /></Link>;
        }
        if (type === 'next') {
            return <Link><img src={nextIcon} alt='USP' /></Link>;
        }
        return originalElement;
    };



    const handlePageViewEdit = (data, reload) => {
        if (reload === "yes") {
            setApicall(!apiCall)
            // setTabLoad(true)
        }

        setCampaignViewId("")
        setCampaignViewName("")
        setCampaignViewCreative(false)

        setPageView(data)

    }

    useEffect(() => {

        axios
            .get(configData.SERVER_URL + "ops/gam/gamPubList", {
                headers: {
                    "Content-Type": "application/json",
                },
            })
            .then((response) => {
                setFilterPublishersOptions(response.data.data)
            })
            .catch((error) => { });

        axios
            .get(configData.SERVER_URL + "ops/gam/campaignMinifiedList", {
                headers: {
                    "Content-Type": "application/json",
                },
            })
            .then((response) => {
                setFilterCampaignsOptions(response.data.data)
            })
            .catch((error) => { });

    }, [])



    const [filterShow, setFilterShow] = useState(false)
    const [filterPublishersOptions, setFilterPublishersOptions] = useState([])
    const [filterCampaignsOptions, setFilterCampaignsOptions] = useState([])

    const [filterApply, setFilterApply] = useState({
        publisher: [],
        campaign: [],
        status: []

    });
    const [filterApplyApiCall, setFilterApplyApiCall] = useState({
        publisher: [],
        campaign: [],
        status: []
    });

    const [searchValuePublisher, setSearchValuePublisher] = useState('');

    const handleSearchPublisher = (e) => {
        setSearchValuePublisher(e.target.value.toLowerCase());
    };

    const filteredOptionsPublisher = filterPublishersOptions.filter(option =>
        option.label.toLowerCase().includes(searchValuePublisher)
    );

    const getLabelsPublisher = (values) => {
        return values.map(value => {
            const publisher = filterPublishersOptions.find(publisher => publisher.value === value);
            return publisher ? publisher.label : value;
        }).join(", ");
    };


    const [searchValueCampaign, setSearchValueCampaign] = useState('');

    const handleSearchCampaign = (e) => {
        setSearchValueCampaign(e.target.value.toLowerCase());
    };

    const filteredOptionsCampaign = filterCampaignsOptions.filter(option =>
        option.label.toLowerCase().includes(searchValueCampaign)
    );

    const getLabelsCampaign = (values) => {
        return values.map(value => {
            const campaign = filterCampaignsOptions.find(campaign => campaign.value === value);
            return campaign ? campaign.label : value;
        }).join(", ");
    };

    const dropdownRef = useRef(null);
    const filterShowRef = useRef(filterShow);
    useEffect(() => {
        filterShowRef.current = filterShow;
    }, [filterShow]);

    useEffect(() => {
        function handleClickOutside(event) {
            if (
                dropdownRef.current &&
                !dropdownRef.current.contains(event.target) &&
                filterShowRef
            ) {
                const selectElement = document.getElementById('adcodeSelect');
                const selectElement2 = document.getElementById('adcodeSelectCampaign');
                if (!selectElement?.closest('.ant-select')?.classList?.contains('ant-select-open') && !selectElement2?.closest('.ant-select')?.classList?.contains('ant-select-open')) {
                    let temp = JSON.parse(JSON.stringify(filterApplyApiCall));

                    setFilterApply(prevState => ({
                        ...prevState,
                        publisher: temp.publisher,
                        campaign: temp.campaign,
                        status: temp.status,

                    }));
                    setFilterShow(false);
                }
            }
        }
        document.addEventListener("mousedown", handleClickOutside);
        return () => {
            document.removeEventListener("mousedown", handleClickOutside);
        };
    });


    useEffect(() => {
        if (!initialLoad) {
            let tempPage = page
            tempPage.current = 1
            setPage(tempPage);
            setApicall(!apiCall)
        }
    }, [filterApplyApiCall])

    function handleFilterApply(type, value) {
        let tempFilterApply = { ...filterApply }
        if (type === "publisher") {
            let newValue = [];
            if (tempFilterApply.publisher.includes(value)) {
                newValue = tempFilterApply.publisher.filter((item) => item !== value);
            } else {
                newValue = [...tempFilterApply.publisher, value];
            }
            tempFilterApply.publisher = newValue
        };

        if (type === "campaign") {
            let newValue = [];
            if (tempFilterApply.campaign.includes(value)) {
                newValue = tempFilterApply.campaign.filter((item) => item !== value);
            } else {
                newValue = [...tempFilterApply.campaign, value];
            }
            tempFilterApply.campaign = newValue
        };

        if (type === "status") {
            const index = filterApply.status.indexOf(value);
            if (index === -1) {
                tempFilterApply.status.push(value);
            } else {
                tempFilterApply.status.splice(index, 1);
            }
        }

        setFilterApply(tempFilterApply)
    }




    const locale = {
        emptyText:
            <>{search.trim().length > 0 && loading ?
                <div className='no_data_screen'>
                    <div className='text-center'>

                        <div className='float_text_div'>

                        </div>
                    </div>
                </div>
                :
                search.trim().length > 0 && !loading ?
                    <div className='no_data_screen'>
                        <div className='text-center'>
                            <img src={errorData} className='' alt="" />
                            <div className='float_text_div'>

                            </div>
                        </div>
                    </div>
                    :
                    (filterApplyApiCall.publisher.length + filterApplyApiCall.campaign.length + filterApplyApiCall.status.length > 0) && loading ?
                        <div className='no_data_screen'>
                            <div className='text-center'>

                                <div className='float_text_div'>

                                </div>
                            </div>
                        </div>
                        :
                        (filterApplyApiCall.publisher.length + filterApplyApiCall.campaign.length + filterApplyApiCall.status.length > 0) && !loading ?
                            <div className='no_data_screen'>
                                <div className='text-center'>
                                    <img src={errorData} className='' alt="" />
                                    <div className='float_text_div'>

                                    </div>
                                </div>
                            </div>
                            :
                            loading ?
                                <div className='no_data_screen'>
                                    <div className='text-center'>

                                        <div className='float_text_div'>

                                        </div>
                                    </div>
                                </div>
                                :
                                <div className='no_data_screen' >
                                    <div className='text-center'>
                                        <img src={noData} className='' alt="" />
                                        <div className='float_text_div'>

                                        </div>
                                    </div>
                                </div>
            }
            </>

    };



    return (
        <>
            <div className="container_box--wrapper pt_header"
                style={{ opacity: pageView === "table" ? 1 : 0, display: pageView === "table" ? "block" : "none" }}
            >
                <div className="container_box--wrapper--title d_flex justify-content-between">
                    <h1 className="heading fw_600"> GAM </h1>
                    {!initialLoad
                        &&
                        <button className='btn btn_primary w_fit_content md'
                            onClick={() => { setPageView("createCampaign") }}
                        >
                            <span><img src={addIcon} alt='Add' /> Campaign</span>
                        </button>
                    }
                </div>

                <div className="d_flex justify_content_between mb_10">
                    <div className='form_content_block--group'>
                        {!initialLoad
                            &&
                            <Input
                                className='form_control basic md search_input w_table_search'
                                placeholder="Search"
                                value={search}
                                onChange={(e) => {

                                    if (e.target.value.trim().length === 0) {
                                        setLoading(true)
                                    }

                                    setSearch(e.target.value)
                                }}
                            />
                        }
                    </div>
                    {!initialLoad
                        &&
                        <>
                            <div className="search_filter_create_new_d2">

                                <div className="custom_filter_design_d2">

                                    <div className="filter_tags_design_d2">
                                        <ul className="p-0 m-0">
                                            {filterApplyApiCall.status.length > 0 &&
                                                <li>
                                                    <div className="d-flex">
                                                        <span className="black_text_d2">Status:</span> {filterApplyApiCall.status.join(", ")}
                                                    </div>
                                                    <button type="button"><img src={tagRomoveIcon} className="" alt=""
                                                        onClick={() => {
                                                            let tempFilterApply = JSON.parse(JSON.stringify(filterApplyApiCall));
                                                            let tempFilterApply2 = JSON.parse(JSON.stringify(filterApplyApiCall));
                                                            tempFilterApply.status = []
                                                            tempFilterApply2.status = []
                                                            setFilterApply(tempFilterApply2)
                                                            setFilterApplyApiCall(tempFilterApply)
                                                        }}
                                                    /> </button>
                                                </li>
                                            }
                                            {filterApplyApiCall.publisher.length > 0 &&
                                                <li>
                                                    <div className="d-flex">
                                                        <span className="black_text_d2">Publisher:</span>
                                                        {getLabelsPublisher(filterApplyApiCall.publisher)?.split(',')?.length === 0 ?
                                                            getLabelsPublisher(filterApplyApiCall.publisher) :
                                                            <>
                                                                <>{getLabelsPublisher(filterApplyApiCall.publisher)?.split(",")[0]} </>
                                                                {getLabelsPublisher(filterApplyApiCall.publisher)?.split(",")?.length > 1 && <>  , &nbsp;+{getLabelsPublisher(filterApplyApiCall.publisher)?.split(",")?.length - 1} ... </>}
                                                            </>}
                                                    </div>
                                                    <button type="button"><img src={tagRomoveIcon} className="" alt=""
                                                        onClick={() => {
                                                            let tempFilterApply = JSON.parse(JSON.stringify(filterApplyApiCall));
                                                            let tempFilterApply2 = JSON.parse(JSON.stringify(filterApplyApiCall));
                                                            tempFilterApply.publisher = []
                                                            tempFilterApply2.publisher = []
                                                            setFilterApply(tempFilterApply2)
                                                            setFilterApplyApiCall(tempFilterApply)
                                                        }}
                                                    /> </button>
                                                </li>
                                            }

                                            {filterApplyApiCall.campaign.length > 0 &&
                                                <li>
                                                    <div className="d-flex">
                                                        <span className="black_text_d2">Campaign:</span>
                                                        {getLabelsCampaign(filterApplyApiCall.campaign)?.split(',')?.length === 0 ?
                                                            getLabelsCampaign(filterApplyApiCall.campaign) :
                                                            <>
                                                                <>{getLabelsCampaign(filterApplyApiCall.campaign)?.split(",")[0]} </>
                                                                {getLabelsCampaign(filterApplyApiCall.campaign)?.split(",")?.length > 1 && <>  , &nbsp;+{getLabelsCampaign(filterApplyApiCall.campaign)?.split(",")?.length - 1} ... </>}
                                                            </>}
                                                    </div>
                                                    <button type="button"><img src={tagRomoveIcon} className="" alt=""
                                                        onClick={() => {
                                                            let tempFilterApply = JSON.parse(JSON.stringify(filterApplyApiCall));
                                                            let tempFilterApply2 = JSON.parse(JSON.stringify(filterApplyApiCall));
                                                            tempFilterApply.campaign = []
                                                            tempFilterApply2.campaign = []
                                                            setFilterApply(tempFilterApply2)
                                                            setFilterApplyApiCall(tempFilterApply)
                                                        }}
                                                    /> </button>
                                                </li>
                                            }
                                        </ul>
                                    </div>

                                    <Dropdown ref={dropdownRef}
                                        show={filterShow} onToggle={() => { setFilterShow(!filterShow) }} className="" autoClose={false}>

                                        <div className="position-relative hover_effec_hide_show_d2">
                                            <Dropdown.Toggle id="dropdown-autoclose-false">
                                                <img src={filterIcon} className="img-fluid" alt="" /> Filter
                                                {filterApplyApiCall?.publisher?.length + filterApplyApiCall?.campaign?.length + filterApplyApiCall?.status?.length > 0 &&
                                                    <span className="selected_filter_tag_d2">
                                                        <div>{filterApplyApiCall?.publisher?.length + filterApplyApiCall?.campaign?.length + filterApplyApiCall?.status?.length}</div>
                                                    </span>
                                                }
                                            </Dropdown.Toggle>
                                            {filterApplyApiCall?.publisher?.length + filterApplyApiCall?.campaign?.length + filterApplyApiCall?.status?.length > 0 &&
                                                <div className="clear_filter_icon_d2">
                                                    <button type="button"> <img src={HoverCloseIcon} alt=""
                                                        onClick={() => {
                                                            setFilterApply({
                                                                publisher: [],
                                                                campaign: [],
                                                                status: []
                                                            })
                                                            setFilterApplyApiCall({
                                                                publisher: [],
                                                                campaign: [],
                                                                status: []
                                                            })
                                                            setFilterShow(false)
                                                        }}
                                                    /> </button>
                                                </div>
                                            }
                                        </div>
                                        <Dropdown.Menu>

                                            <div className="filter_inner_heading_d2">

                                                <p className="m-0">Publisher</p>
                                                <div className="checkbox_value_select_d2 multi_select_tag_d2 w-100">

                                                    <Select
                                                        id="adcodeSelect"
                                                        // {...sharedProps}
                                                        // value={selectedPublishers}
                                                        value={filterApply.publisher}
                                                        popupClassName='diff_select_d2'
                                                        // onChange={setValue}
                                                        showSearch={false}
                                                        placeholder='- Select -'
                                                        className="form_select basic error"
                                                        mode='multiple'
                                                        maxTagCount='responsive'
                                                        dropdownRender={menu => (
                                                            <>
                                                                <div className="custom_inside_searchbar_d2">
                                                                    <Input placeholder="Search" value={searchValuePublisher} onChange={handleSearchPublisher} prefix={<SearchOutlined className="search_icon_d2" />} allowClear />
                                                                </div>
                                                                {menu}
                                                            </>
                                                        )}
                                                    >

                                                        {filteredOptionsPublisher.map(option => (
                                                            <Select.Option key={option.value} value={option.value}>
                                                                <div
                                                                    onClick={() => handleFilterApply("publisher", option.value)}
                                                                    style={{ display: 'flex', alignItems: 'center' }}
                                                                >
                                                                    <Checkbox
                                                                        checked={filterApply.publisher.includes(option.value)}
                                                                        onClick={(e) => e.stopPropagation()}
                                                                    >
                                                                        {option.label}
                                                                    </Checkbox>
                                                                </div>
                                                            </Select.Option>
                                                        ))}
                                                    </Select>
                                                </div>
                                                <hr />
                                            </div>


                                            <div className="filter_inner_heading_d2">

                                                <p className="m-0">Campaign</p>
                                                <div className="checkbox_value_select_d2 multi_select_tag_d2 w-100">

                                                    <Select
                                                        id="adcodeSelectCampaign"
                                                        // {...sharedProps}
                                                        // value={selectedPublishers}
                                                        value={filterApply.campaign}
                                                        popupClassName='diff_select_d2'
                                                        // onChange={setValue}
                                                        showSearch={false}
                                                        placeholder='- Select -'
                                                        className="form_select basic error"
                                                        mode='multiple'
                                                        maxTagCount='responsive'
                                                        dropdownRender={menu => (
                                                            <>
                                                                <div className="custom_inside_searchbar_d2">
                                                                    <Input placeholder="Search" value={searchValueCampaign} onChange={handleSearchCampaign} prefix={<SearchOutlined className="search_icon_d2" />} allowClear />
                                                                </div>
                                                                {menu}
                                                            </>
                                                        )}
                                                    >

                                                        {filteredOptionsCampaign.map(option => (
                                                            <Select.Option key={option.value} value={option.value}>
                                                                <div
                                                                    onClick={() => handleFilterApply("campaign", option.value)}
                                                                    style={{ display: 'flex', alignItems: 'center' }}
                                                                >
                                                                    <Checkbox
                                                                        checked={filterApply.campaign.includes(option.value)}
                                                                        onClick={(e) => e.stopPropagation()}
                                                                    >
                                                                        {option.label}
                                                                    </Checkbox>
                                                                </div>
                                                            </Select.Option>
                                                        ))}
                                                    </Select>
                                                </div>
                                                <hr />
                                            </div>

                                            <div className="filter_inner_heading_d2">
                                                <p className="m-0">Status</p>
                                                <div className="checkbox_value_select_d2">
                                                    <div className="checkbox_active_design_d2">
                                                        <input type="checkbox" name="statuspending" id="statuspending"
                                                            checked={filterApply.status.includes("Pending")}
                                                            onChange={() => { handleFilterApply("status", "Pending") }}
                                                        />
                                                        <label htmlFor="statuspending" className="single_checkbox_select_d2">
                                                            Pending
                                                        </label>
                                                    </div>
                                                    <div className="checkbox_active_design_d2">
                                                        <input type="checkbox" name="statusapproved" id="statusapproved"
                                                            checked={filterApply.status.includes("Approved")}
                                                            onChange={() => { handleFilterApply("status", "Approved") }}
                                                        />
                                                        <label htmlFor="statusapproved" className="single_checkbox_select_d2">
                                                            Approved
                                                        </label>
                                                    </div>
                                                    <div className="checkbox_active_design_d2">
                                                        <input type="checkbox" name="statusdeclined" id="statusdeclined"
                                                            checked={filterApply.status.includes("Declined")}
                                                            onChange={() => { handleFilterApply("status", "Declined") }}
                                                        />
                                                        <label htmlFor="statusdeclined" className="single_checkbox_select_d2">
                                                            Declined
                                                        </label>
                                                    </div>
                                                </div>
                                                <hr />
                                            </div>
                                            <div className="filter_bottom_btns_d2 text-end">
                                                <button className="reset" type='button'
                                                    onClick={() => {
                                                        setFilterApply({
                                                            publisher: [],
                                                            campaign: [],
                                                            status: []
                                                        })
                                                        setFilterApplyApiCall({
                                                            publisher: [],
                                                            campaign: [],
                                                            status: []
                                                        })
                                                        setFilterShow(false)
                                                    }}

                                                >Reset</button>
                                                <button className="apply" type='button'
                                                    onClick={() => {
                                                        let tempdata = JSON.parse(JSON.stringify(filterApply));
                                                        setFilterApplyApiCall(tempdata)
                                                        setFilterShow(false)
                                                    }}
                                                >Apply</button>
                                            </div>
                                        </Dropdown.Menu>
                                    </Dropdown>
                                </div>
                            </div>

                        </>
                    }
                </div>


                <div className="table_content--box table_empty_screen_d2">
                    {loading && !initialLoad
                        &&
                        <div className="table_new_loader_d2">
                            <img src={FullLoader} className="img-fluid" alt="" />
                        </div>
                    }

                    {initialLoad
                        ?
                        <TableLoader />

                        :
                        <>

                            <Table
                                columns={columns}
                                pageSize={100}
                                dataSource={data}
                                onChange={handleTableChange}
                                pagination={false}
                                rowKey={(record) => record.id}
                                locale={locale}
                                scroll={{ x: 'max-content', y: 'calc(100vh - 27rem' }} />
                        </>
                    }

                    {data.length > 0 &&
                        <Row className="custom_pagination--container">
                            <Col span={6}>
                                <div className="form_content_block--group mb_0">
                                    <Select
                                        className='form_select basic sm no_search'
                                        value={page.pageSize}
                                        onChange={handlePageSizeChange}
                                        style={{ width: 80 }}
                                        showSearch={false}
                                        options={[
                                            { value: 10, label: 10 },
                                            { value: 20, label: 20 },
                                            { value: 50, label: 50 },
                                            { value: 100, label: 100 },
                                        ]} />
                                    <label className='custom_pagination--label'>
                                        items per page
                                    </label>
                                </div>
                            </Col>
                            <Col span={6}>
                                <span className="custom_pagination--total-text">
                                    {`${(page.current - 1) * page.pageSize + 1}-${Math.min(page.current * page.pageSize, page.total)} of ${page.total} items`}
                                </span>
                            </Col>
                            <Col span={6}>
                                <Pagination
                                    current={page.current}
                                    pageSize={page.pageSize}
                                    total={page.total}
                                    onChange={handlePageChange}
                                    showSizeChanger={false}
                                    itemRender={itemRender}
                                    className="custom_pagination" />
                            </Col>
                        </Row>
                    }
                </div>
            </div>

            {pageView === "createCampaign" &&
                <CampaignCreateGam
                    handlePageViewChange={handlePageViewEdit}

                />
            }

            {pageView === "viewCampaign" &&
                <CampaignViewEditGam
                    handlePageViewChange={handlePageViewEdit}
                    campaignViewId={campaignViewId}
                    campaignViewName={campaignViewName}
                    campaignViewCreative={campaignViewCreative}
                />
            }





        </>
    );
};

export default CampaignListGam;
